export default "__VITE_ASSET__B2pAr30O__"